<template>
  <div class="page-container">
    <el-card class="mb-20">
      <app-filter
        :filter-list="table_filter"
        default-label-width="100px"
        @search="search"
      />
    </el-card>
    <el-card>
      <div class="flex justify-between mb-20">
        <div>
          <el-select v-model="batch.value" size="mini" class="mr-20" placeholder="请选择批量操作">
            <el-option
              v-for="item in batch.options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
          <el-button size="mini" type="primary" @click="onBatch">批量操作</el-button>
        </div>
        <el-button size="mini" type="primary" @click="add">新增</el-button>
      </div>
      <app-table
        ref="table"
        :table-key="table_key"
        :tablep="table_params"
        :get-data="getEnumList"
      />
    </el-card>
    <!-- 新增/编辑弹窗 -->
    <el-dialog
      :title="dialog_config.title"
      :visible.sync="dialog_config.is_show"
      width="500px"
    >
      <app-form
        v-if="dialog_config.is_show"
        :form-data="dialog_config.form_config"
        default-label-width="100px"
        @confirm="dialog_config.confirm"
        @cancel="dialog_config.is_show = false"
      />
    </el-dialog>
    <!-- 批量新增弹窗 -->
    <el-drawer
      size="600px"
      :title="batch_add_drawer_config.title"
      :visible.sync="batch_add_drawer_config.is_show"
      :close-on-press-escape="false"
      :wrapper-closable="false"
    >
      <div class="pl-20 pr-20">
        <app-form
          v-if="batch_add_drawer_config.is_show"
          ref="batch_add_form"
          :form-data="batch_add_drawer_config.form_config"
          default-label-width="100px"
          :is-show-button="false"
          @confirm="batch_add_drawer_config.confirm"
        >
          <template #custom="{ form_key, form_item }">
            <div v-if="form_key === 'batch'">
              <div class="mb-20 text-right">
                <el-button size="mini" plain @click="batch_add_drawer_config.addEnum(form_item)">新增枚举项</el-button>
              </div>
              <el-card v-for="(item, i) in form_item.value" :key="i" shadow="never" class="mb-20">
                <span>{{ '枚举项' + (i + 1) }}</span>
                <div class="flex justify-between align-center">
                  <div class="flex-1">
                    <div class="flex mb-20">
                      <label>枚举值名</label>
                      <el-input v-model="item.enum_name" placeholder="请输入枚举值名" />
                    </div>
                    <div class="flex">
                      <label>枚举描述</label>
                      <el-input v-model="item.enum_desc" placeholder="请输入枚举描述" />
                    </div>
                  </div>
                  <div class="ml-20">
                    <i class="el-icon-remove-outline cursor-pointer" style="font-size: 36px;" @click="batch_add_drawer_config.delEnum(form_item, i)" />
                  </div>
                </div>
              </el-card>
            </div>
          </template>
        </app-form>
      </div>
      <div class="drawer-footer-wrapper p-20 w-full absolute right-0 bottom-0 bg-white">
        <div class="text-center">
          <el-button @click="batch_add_drawer_config.is_show = false">取 消</el-button>
          <el-button type="primary" :loading="batch_add_drawer_config.loading" @click="batch_add_drawer_config.onSubmit">确 定</el-button>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import EnumResource from '@/api/tool/enum';
const enumResource = new EnumResource();

import { formDataAssign } from '@/tools/form';

export default {
  name: 'EnumManage',
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
    'app-form': () => import('@/components/app-form'),
  },
  data() {
    return {
      /** 过滤项 */
      table_filter: require('./model/table-filter')(this),
      /** 表头数据 */
      table_key: require('./model/table-key')(this),
      /** 表格请求参数 */
      table_params: {
        type: 'jrtt',
        page: 1,
        limit: 10,
      },
      /** 弹窗配置 */
      dialog_config: {
        is_show: false,
        title: '新增',
        id: null,
        form_config: {},
        confirm: () => {},
      },
      /** 批量操作 */
      batch: {
        value: 'add',
        options: [
          {
            label: '批量新增',
            value: 'add',
          },
        ],
      },
      /** 批量新增抽屉配置 */
      batch_add_drawer_config: {
        loading: false,
        is_show: false,
        title: '批量新增',
        form_config: {},
        confirm: () => {},
        onSubmit: () => {
          const { batch: { value = [] } = {}} = this.batch_add_drawer_config.form_config;
          const index = value.findIndex(({ enum_name, enum_desc }) => !(enum_name && enum_desc));
          if (index !== -1) {
            this.$message.warning(`枚举项${index + 1} 有未填的枚举值名或枚举描述！`);
            return;
          }
          this.$refs.batch_add_form.confirm();
        },
        addEnum: (item) => item.value.push({ enum_name: '', enum_desc: '' }),
        delEnum: (item, i) => {
          if (item.value.length === 1) {
            this.$message.warning('枚举项至少一项！');
            return;
          }
          item.value.splice(i, 1);
        },
      },
    };
  },
  methods: {
    /** 搜索 */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },
    /** 新增 */
    add() {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '新增',
        form_config: require('./model/form-config.js')(),
        confirm: (params) => {
          enumResource.creatApi(params)
            .then(() => {
              this.$message.success('新增成功！');
              this.dialog_config.is_show = false;
              this.$refs.table.seekTable();
            });
        },
      });
      this.dialog_config.form_config.type.value = this.table_params.type;
    },
    /**
     * 编辑
     * @param {object} data 列表项数据
     * @param {number} id 枚举ID
     */
    edit(data, id) {
      Object.assign(this.dialog_config, {
        is_show: true,
        title: '编辑',
        id,
        form_config: require('./model/form-config.js')(),
        confirm: (params) => {
          enumResource.editApi(params, this.dialog_config.id)
            .then(() => {
              this.$message.success('编辑成功！');
              this.dialog_config.is_show = false;
              this.$refs.table.refer();
            });
        },
      });

      formDataAssign(this.dialog_config.form_config, data);
    },
    /**
     * 删除
     * @param {number} id 枚举ID
     */
    delete(id) {
      this.$confirm('是否删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        enumResource.deleteApi(id)
          .then(() => {
            this.$message.success('删除成功！');
            this.$refs.table.seekTable();
          });
      });
    },
    /** 批量操作 */
    onBatch() {
      switch (this.batch.value) {
        case 'add':
          this.batchAdd();
          break;
        default:
          break;
      }
    },
    /** 批量新增 */
    batchAdd() {
      Object.assign(this.batch_add_drawer_config, {
        is_show: true,
        form_config: require('./model/batch-add-form-config.js')(),
        confirm: (params) => {
          const { batch, ...rest } = params;
          this.batch_add_drawer_config.loading = true;
          let is_all_success = true;
          const err_msg = [];
          const promise_list = batch.map(item => {
            return enumResource.creatApi({ ...item, ...rest }).catch(() => {
              is_all_success = false;
              err_msg.push(item);
            });
          });
          Promise.allSettled(promise_list).then(() => {
            if (is_all_success) {
              this.$message.success('新增成功！');
            } else {
              this.$notify({
                title: '以下枚举项新增失败',
                message: err_msg.map(({ enum_name, enum_desc }) => `枚举值名：${enum_name}<br>枚举描述：${enum_desc}<br>`).join('<br>'),
                duration: 0,
                dangerouslyUseHTMLString: true,
                type: 'error',
              });
            }
            this.batch_add_drawer_config.is_show = false;
            this.batch_add_drawer_config.loading = false;
            this.$refs.table.seekTable();
          });
        },
      });
      this.batch_add_drawer_config.form_config.type.value = this.table_params.type;
    },
    /**
     * 获取枚举值列表
     * @param {object} data 过滤参数
     */
    getEnumList(data) {
      return new Promise((resolve, reject) => {
        enumResource.getApi(data)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.el-drawer__body {
  padding: 0 0 77px 0;
}
label {
  padding-right: 12px;
  text-align: right;
  width: 100px;
  line-height: 28px;
  font-size: 14px;
  color: #606266;
}
.el-icon-remove-outline:hover {
  color: #F56C6C;
}
</style>
